module.exports = require("core-js/library/fn/set");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/set.js
// module id = ./node_modules/@babel/runtime/core-js/set.js
// module chunks = 0